import '@abraham/reflection';

import {
    ClassConstructor,
    ClassTransformOptions,
    instanceToPlain,
    plainToInstance,
} from 'class-transformer';

const defaultOptions: ClassTransformOptions = {
    excludeExtraneousValues: true,
    enableImplicitConversion: true,
};

export const deserialize = <T, V>(
    cls: ClassConstructor<T>,
    plain: V,
    options?: ClassTransformOptions
) => {
    options = { ...defaultOptions, ...options };
    return plainToInstance(cls, plain, options);
};

export const deserializeArray = <T, V>(
    cls: ClassConstructor<T>,
    plain: V[],
    options?: ClassTransformOptions
) => {
    options = { ...defaultOptions, ...options };
    return plainToInstance(cls, plain, options);
};

export const serialize = <T>(object: T, options?: ClassTransformOptions) => {
    options = { ...defaultOptions, ...options };
    return instanceToPlain(object, options);
};

export const serializeArray = <T>(
    object: T[],
    options?: ClassTransformOptions
) => {
    options = { ...defaultOptions, ...options };
    return instanceToPlain(object, options);
};
